export default "__VITE_ASSET__Bbj6OR5A__"